import __request__ from "routing/request";
export function indexSetConfig(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.archive/archives/index_set/config", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function updateIndexSetConfig(JSONbody, requestOptions) {
  return __request__("PUT", "/plugins/org.graylog.plugins.archive/archives/index_set/config", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function indexSetOverview(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.archive/archives/index_set/indexer/overview", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function rebuildIndexRanges(requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.archive/archives/index_set/ranges/rebuild", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
